import { Button } from "@/components/elements/Button";
import { AppRoutes } from "@/routes/config";
import { Stack } from "@mui/material";
import { FC } from "react";
import { Link } from "react-router-dom";

type TInformationListTopProps = {};

export const InformationListTop: FC<TInformationListTopProps> = () => {
  return (
    <Stack direction="row" justifyContent="flex-end" alignItems="center">
      <Button component={Link} size="sm" variant="outline" to={AppRoutes.informationCreate}>
        新規作成
      </Button>
    </Stack>
  );
};
